export default "__VITE_ASSET__eeb28c5c__"